/** 点击表格中的一行后记住它，列表刷新后仍标出同一行。 */

const selectedKey = new WeakMap<HTMLTableElement, string>();

function isPlaceholder(row: HTMLTableRowElement): boolean {
  return row.cells.length === 1 && row.cells[0].colSpan > 1;
}

function rowKey(row: HTMLTableRowElement): string {
  return row.dataset.rowKey || Array.from(row.cells).map((cell) => cell.innerText.trim()).join('\u0001');
}

function paint(table: HTMLTableElement): void {
  const key = selectedKey.get(table) ?? '';
  for (const body of table.tBodies) {
    for (const row of body.rows) {
      row.classList.toggle('row-selected', key !== '' && !isPlaceholder(row) && rowKey(row) === key);
    }
  }
}

export function installSelectedRows(): void {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const row = event.target.closest('table.data-table tbody tr');
    if (!(row instanceof HTMLTableRowElement) || isPlaceholder(row)) return;
    const table = row.closest('table');
    if (!(table instanceof HTMLTableElement)) return;
    selectedKey.set(table, rowKey(row));
    paint(table);
  });

  const observer = new MutationObserver((mutations) => {
    const tables = new Set<HTMLTableElement>();
    for (const mutation of mutations) {
      const node = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
      const table = node?.closest('table.data-table');
      if (table instanceof HTMLTableElement) tables.add(table);
    }
    for (const table of tables) paint(table);
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
}
